const isLocalhost = window.location.hostname === 'localhost';

export const globalVariables = {
  ssoDomain: window.SSO_DOMAIN || process.env.SSO_DOMAIN,
  apiDomain: window.KONG_API_DOMAIN || process.env.KONG_API_DOMAIN,
  appId: window.ECA_APP_ID || process.env.APPLICATION_ID,
  userData: window.USER_DATA || process.env.USER_DATA,
  caDomain: (isLocalhost ? location.origin : window.CA_DOMAIN || '') + '/', //proxy to 'https://ca.nonprod.3d4medical.com/'
  pendoApiKey: window.PENDO_API_KEY || process.env.PENDO_API_KEY,
  userAccount: 'https://myaccount.elsevier.com/',
  cookieSrc: window.ONETRUST_SRC || process.env.ONETRUST_SRC || '',
  cookieId: window.ONETRUST_ID || process.env.ONETRUST_ID || '',
};
